<template>
  <div class="container">
    <modal-import
      :visible="visibleModalImport"
      :box_id="id"
      @hide="visibleModalImport = !visibleModalImport"
      @submit="successImport"
    ></modal-import>
    <modal-detail
      :visible="visibleModalDetail"
      :title="'Detalle Carpeta'"
      @hide="visibleModalDetail = !visibleModalDetail"
    >
      <vue-custom-scrollbar class="scroll-area">
        <div class="info-registro" v-if="show_carpeta">
          <div class="registros">
            <div class="registro">
              <div class="font-weight-bold">Fecha Registro: {{ show_carpeta.created_at }}</div>
            </div>
            <div class="registro">
              <div class="font-weight-bold">Fecha Modificado: {{ show_carpeta.updated_at }}</div>
            </div>
          </div>
          <div class="estado">
            <span v-html="templateEstado(show_carpeta.estado)"></span>
          </div>
        </div>
        <div class="detalle-servicio" v-if="show_carpeta">
          <div class="detalle">
            <div class="font-weight-bold">N° de Declaración :</div>
            <div class="valor">{{ show_carpeta.nro_declaracion }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">N° Interno :</div>
            <div class="valor">{{ show_carpeta.nro_registro }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Aduana Trámite :</div>
            <div class="valor">{{ show_carpeta.aduana_tramite }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Fecha Aceptación :</div>
            <div class="valor">{{ show_carpeta.fecha_aceptacion }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Régimen Aduanero :</div>
            <div class="valor">{{ show_carpeta.regimen_aduanero }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Modalidad del Régimen :</div>
            <div class="valor">{{ show_carpeta.modalidad_regimen }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Modalidad de Despacho :</div>
            <div class="valor">{{ show_carpeta.modalidad_despacho }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Importador :</div>
            <div class="valor">{{ show_carpeta.importador }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Declarante :</div>
            <div class="valor">{{ show_carpeta.declarante }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">País de Exportación :</div>
            <div class="valor">{{ show_carpeta.pais_exportacion }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Aduana Ingreso:</div>
            <div class="valor">{{ show_carpeta.aduana_ingreso }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Total N° Facturas :</div>
            <div class="valor">{{ show_carpeta.total_nro_facturas }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Total N° Items :</div>
            <div class="valor">{{ show_carpeta.total_nro_items }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Total N° Bultos :</div>
            <div class="valor">{{ show_carpeta.total_nro_bultos }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Total Peso Bruto :</div>
            <div class="valor">{{ show_carpeta.total_peso_bruto }}</div>
          </div>
          <div class="detalle">
            <div class="font-weight-bold">Total Valor Fob :</div>
            <div class="valor">{{ show_carpeta.total_valor_fob }}</div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </modal-detail>
    <modal-form
      :visible="visibleModalForm"
      :title="carpeta.id == null ? 'Registrar Carpeta' : 'Actualizar Carpeta'"
      @hide="closeModalForm"
    >
    <fieldset class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <legend>Datos Generales:</legend>
      <a-spin :spinning="success">
        <div class="container">
          <div class="d-flex flex-row-reverse bd-highlight">
            <small><strong>Los campos con (*) son obligatorios.</strong></small>
          </div>
          <b-form @submit.stop.prevent="submitCarpeta">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="nro_declaracion">N° Declaración :</label>
                </strong>
                <b-form-group label-for="nro_declaracion" :invalid-feedback="errors.first('nro_declaracion')" :state="!errors.has('nro_declaracion')">
                  <b-form-input 
                    v-model="carpeta.nro_declaracion" 
                    :state="errors.has('nro_declaracion') ? false : null"
                    v-validate="'required|max:64'"
                    data-vv-name="nro_declaracion"
                    data-vv-as="n° declaración"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="nro_registro">N° Interno * :</label>
                </strong>
                <b-form-group label-for="nro_registro" :invalid-feedback="errors.first('nro_registro')" :state="!errors.has('nro_registro')">
                  <b-form-input 
                    v-model="carpeta.nro_registro" 
                    :state="errors.has('nro_registro') ? false : null"
                    v-validate="'required|max:32'"
                    data-vv-name="nro_registro"
                    data-vv-as="n° registro"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="fecha_aceptacion">Fecha Aceptación * :</label>
                </strong>
                <b-form-group label-for="fecha_aceptacion" :invalid-feedback="errors.first('fecha_aceptacion')" :state="!errors.has('fecha_aceptacion')">
                  <b-form-input 
                    v-model="carpeta.fecha_aceptacion" 
                    :state="errors.has('fecha_aceptacion') ? false : null"
                    v-validate="'max:64'"
                    data-vv-name="fecha_aceptacion"
                    data-vv-as="fecha aceptación"
                    type="date"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <strong>
                  <label for="aduana_id">Aduana Trámite * :</label>
                </strong>
                <b-form-group label-for="aduana_id" :invalid-feedback="errors.first('aduana_id')" :state="!errors.has('aduana_id')">
                  <!-- <b-form-input 
                    v-model="carpeta.aduana_id" 
                    :state="errors.has('aduana_id') ? false : null"
                    v-validate="'required|max:64'"
                    data-vv-name="aduana_id"
                    data-vv-as="aduana trámite"
                    type="text"
                  ></b-form-input> -->
                  <v-select
                    label="text"
                    v-model="carpeta.aduana_id" 
                    :options="aduanas"
                    :reduce="aduana => aduana.id"
                    :state="errors.has('aduana_id') ? false : null"
                    v-validate="'required'"
                    data-vv-name="aduana_id"
                    data-vv-as="aduana trámite"
                  ></v-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                <strong>
                  <label for="regimen_aduanero">Régimen Aduanero :</label>
                </strong>
                <b-form-group label-for="regimen_aduanero" :invalid-feedback="errors.first('regimen_aduanero')" :state="!errors.has('regimen_aduanero')">
                  <b-form-input 
                    v-model="carpeta.regimen_aduanero" 
                    :state="errors.has('regimen_aduanero') ? false : null"
                    v-validate="'required|max:64'"
                    data-vv-name="regimen_aduanero"
                    data-vv-as="cliente"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                <strong>
                  <label for="modalidad_regimen">Modalidad Régimen :</label>
                </strong>
                <b-form-group label-for="modalidad_regimen" :invalid-feedback="errors.first('modalidad_regimen')" :state="!errors.has('modalidad_regimen')">
                  <b-form-input
                    v-model="carpeta.modalidad_regimen"  
                    :state="errors.has('modalidad_regimen') ? false : null"
                    v-validate="'required|max:32'"
                    data-vv-name="modalidad_regimen"
                    data-vv-as="modalidad régimen"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="modalidad_despacho">Modalidad Despacho :</label>
                </strong>
                <b-form-group label-for="modalidad_despacho" :invalid-feedback="errors.first('modalidad_despacho')" :state="!errors.has('modalidad_despacho')">
                  <b-form-input
                    v-model="carpeta.modalidad_despacho"   
                    :state="errors.has('modalidad_despacho') ? false : null"
                    v-validate="'max:64'"
                    data-vv-name="modalidad_despacho"
                    data-vv-as="modalidad despachoo"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="importador">Importador :</label>
                </strong>
                <b-form-group label-for="importador" :invalid-feedback="errors.first('importador')" :state="!errors.has('importador')">
                  <b-form-input 
                    v-model="carpeta.importador"  
                    :state="errors.has('importador') ? false : null"
                    v-validate="'required|max:32'"
                    data-vv-name="importador"
                    data-vv-as="importador"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="declarante">Declarante :</label>
                </strong>
                <b-form-group label-for="declarante" :invalid-feedback="errors.first('declarante')" :state="!errors.has('declarante')">
                  <b-form-input 
                    v-model="carpeta.declarante"  
                    :state="errors.has('declarante') ? false : null"
                    v-validate="'max:64'"
                    data-vv-name="declarante"
                    data-vv-as="declarante"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="pais_exportacion">País Exportación :</label>
                </strong>
                <b-form-group label-for="pais_exportacion" :invalid-feedback="errors.first('pais_exportacion')" :state="!errors.has('pais_exportacion')">
                  <b-form-input 
                    v-model="carpeta.pais_exportacion"  
                    :state="errors.has('pais_exportacion') ? false : null"
                    v-validate="'max:64'"
                    data-vv-name="pais_exportacion"
                    data-vv-as="pais exportación"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="aduana_ingreso">Aduana Ingreso :</label>
                </strong>
                <b-form-group label-for="aduana_ingreso" :invalid-feedback="errors.first('aduana_ingreso')" :state="!errors.has('aduana_ingreso')">
                  <b-form-input 
                    v-model="carpeta.aduana_ingreso"  
                    :state="errors.has('aduana_ingreso') ? false : null"
                    v-validate="'required|max:32'"
                    data-vv-name="aduana_ingreso"
                    data-vv-as="aduana ingreso"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <strong>
                  <label for="total_nro_facturas">Total N° Facturas :</label>
                </strong>
                <b-form-group label-for="total_nro_facturas" :invalid-feedback="errors.first('total_nro_facturas')" :state="!errors.has('total_nro_facturas')">
                  <b-form-input 
                    v-model="carpeta.total_nro_facturas"  
                    :state="errors.has('total_nro_facturas') ? false : null"
                    v-validate="'max:64'"
                    data-vv-name="total_nro_facturas"
                    data-vv-as="total n° facturas"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                <strong>
                  <label for="total_nro_items">Total N° Items :</label>
                </strong>
                <b-form-group label-for="total_nro_items" :invalid-feedback="errors.first('total_nro_items')" :state="!errors.has('total_nro_items')">
                  <b-form-input
                    v-model="carpeta.total_nro_items"   
                    :state="errors.has('total_nro_items') ? false : null"
                    v-validate="'max:64'"
                    data-vv-name="total_nro_items"
                    data-vv-as="total n° items"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                <strong>
                  <label for="total_nro_bultos">Total N° Bultos :</label>
                </strong>
                <b-form-group label-for="total_nro_bultos" :invalid-feedback="errors.first('total_nro_bultos')" :state="!errors.has('total_nro_bultos')">
                  <b-form-input 
                    v-model="carpeta.total_nro_bultos"  
                    :state="errors.has('total_nro_bultos') ? false : null"
                    v-validate="'required|max:32'"
                    data-vv-name="total_nro_bultos"
                    data-vv-as="total n° bultos"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                <strong>
                  <label for="total_peso_bruto">Total Peso Bruto :</label>
                </strong>
                <b-form-group label-for="total_peso_bruto" :invalid-feedback="errors.first('total_peso_bruto')" :state="!errors.has('total_peso_bruto')">
                  <b-form-input 
                    v-model="carpeta.total_peso_bruto"  
                    :state="errors.has('total_peso_bruto') ? false : null"
                    v-validate="'max:64'"
                    data-vv-name="total_peso_bruto"
                    data-vv-as="total peso brutoo"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                <strong>
                  <label for="total_valor_fob">Total Valor Fob :</label>
                </strong>
                <b-form-group label-for="total_valor_fob" :invalid-feedback="errors.first('total_valor_fob')" :state="!errors.has('total_valor_fob')">
                  <b-form-input
                    v-model="carpeta.total_valor_fob"   
                    :state="errors.has('total_valor_fob') ? false : null"
                    v-validate="'max:64'"
                    data-vv-name="total_valor_fob"
                    data-vv-as="total valor fob"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row my-2">
              <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                <div>
                  <!-- <button @click="enfocarInput">Enfocar Input</button>
                  <input v-model="codigoEscaneado" @keydown="capturarEscaneo" ref="inputHidden" type="text" tabindex="-1" /> -->
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                <b-button 
                  type="submit" 
                  class="float-right" 
                  variant="dark"
                ><i class="fa fa-check-circle" aria-hidden="true"></i> {{ carpeta.id == null ? 'REGISTRAR' : 'ACTUALIZAR' }}</b-button>
                <b-button @click="closeModalForm" class="mr-2 float-right" variant="secondary"><i class="fa fa-times-circle" aria-hidden="true"></i> CANCELAR</b-button>
              </div>
            </div>
          </b-form>
          <button @click="iniciarEscaneo">Iniciar Escaneo</button>
                  <p>Resultado del escaneo: {{ resultadoEscaneo }}</p>
        </div>
      </a-spin>
    </fieldset>
    </modal-form>
    <modal-questtion
      :title="'Alerta'"
      :visible="visibleModalQuestion"
      :alert_message="'Realmente desea eliminar este registro?'"
      :loading="loadingDelete"
      @hide="visibleModalQuestion = !visibleModalQuestion"
      @submit="deleteCarpeta"
    >
    </modal-questtion>
    <div class="d-flex flex-wrap bg-light bd-highlight rounded" v-if="box">
      <div class="p-2 flex-grow-1 bd-highlight">
        <h5 class="pt-2 font-weight-bold">Caja N° {{ box.cod_interno }}</h5>
      </div>
      <div class="p-2 bd-highlight">
        <h5 class="pt-2 font-weight-bold">CUBI: {{ box.ubigeo.codigo }}</h5>
      </div>
      <div class="p-2 bd-highlight">
        <h5 class="pt-2 font-weight-bold">{{ box.estado.title }}</h5>
      </div>
    </div>
    <hr>
    <div class="d-flex flex-wrap">
      <div class="mr-auto">
        <h5 class="font-weight-bold">DETALLE CONTENIDO</h5>
      </div>
      <div>
        <span class="font-weight-bold">Total registros({{ totalCarpetas }})</span>
      </div>
    </div>
    <br>
    <div class="d-flex flex-sm-row flex-column bg-custom">
      <div class="mr-auto p-2">
        <b-button @click="pdfListFolders" title="Descargar Lista PDF" size="sm" variant="danger" class="ml-2">
          <i class="fa fa-file-pdf-o"></i>
        </b-button>
        <b-button @click="excelListFolders" title="Descargar Lista EXCEL" size="sm" variant="success" class="ml-2">
          <i class="fa fa-file-excel-o"></i>
        </b-button>
        <b-button @click="visibleModalImport = !visibleModalImport" title="Importar Datos" size="sm" variant="outline-warning" class="ml-2">
          <i class="fa fa-upload"></i> Importar
        </b-button>
        <b-button @click="openModalForm()" title="Importar Datos" size="sm" variant="outline-secondary" class="ml-2">
          <i class="fa fa-plus-circle"></i> Registrar nueva
        </b-button>
      </div>
      <div class="p-2">
        <b-form-group
          label="Filtrar"
          label-for="filter-input"
          label-cols-sm="2"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Buscar"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"><i class="fa fa-window-close" aria-hidden="true"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="p-2">
        <b-button @click="showFoldersBox" title="Actualizar Tabla" size="sm" variant="dark" class="mr-2">
          <i class="fa fa-repeat"></i> Recargar
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <b-table class="text-center" thead-class="bg-success text-white" :busy="isBusy" fixed striped hover small :items="records" :fields="columns" responsive="sm" stacked="sm" :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" show-empty>
          <template v-slot:empty="scope">
            <div class="text-center">
              <i class="fa fa-search-minus fa-3x" aria-hidden="true"></i>
              <h6>No existen resultados</h6>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:head(nro_declaracion)="data">
            <span>{{ data.label.toUpperCase() }}</span>
          </template>
          <template v-slot:head(nro_registro)="data">
            <span>{{ data.label.toUpperCase() }}</span>
          </template>
          <template v-slot:head(fecha_aceptacion)="data">
            <span>{{ data.label.toUpperCase() }}</span>
          </template>
          <template v-slot:head(estado)="data">
            <span>{{ data.label.toUpperCase() }}</span>
          </template>
          <template v-slot:head(opciones)="data">
            <span>{{ data.label.toUpperCase() }}</span>
          </template>
          <template v-slot:cell(nro_declaracion)="data">
            <strong>{{ data.value }}</strong>
          </template>
          <template v-slot:cell(nro_registro)="data">
            <strong>{{ data.value }}</strong>
          </template>
          <template v-slot:cell(fecha_aceptacion)="data">
            <strong>{{ data.value | formatDate('DD/MM/YYYY') }}</strong>
          </template>
          <template v-slot:cell(estado)="data">
            <span v-html="templateEstado(data.value)"></span>
          </template>
          <template v-slot:cell(opciones)="row">
            <b-button @click="showCarpeta(row.item)" size="sm" class="mr-2" variant="outline-dark">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </b-button>
            <b-button @click="editCarpeta(row.item)" size="sm" class="mr-2" variant="outline-dark">
              <i class="fa fa-pencil" aria-hidden="true"></i>
            </b-button>
            <b-button @click="questionDeleteCarpeta(row.item)" size="sm" class="mr-2" variant="outline-dark">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import "vue-custom-scrollbar/dist/vueScrollbar.css"
  import permission from '../../mixins/permission'
  import BoxService from '../../services/box.service'
  import AduanaService from '../../services/aduana.service'
  import Carpeta from '../../models/Carpeta'
  import ModalImport from "../../components/widgets/Modals/ModalImport.vue"
  import ModalDetail from "../../components/widgets/Modals/ModalDetail.vue"
  import ModalForm from "../../components/widgets/Modals/ModalForm"
  import ModalQuestion from "../../components/widgets/Modals/ModalQuestion.vue"
  
  export default {
    data() {
      return {
        id: this.$route.params.id,
        box: null,
        totalItems: 0,
        sort: 'desc',
        sortItems: [
          { text: 'ASC ▲', value: 'asc' },
          { text: 'DESC ▼', value: 'desc' },
        ],
        records: [],
        isBusy: false,
        columns: [
          { key: 'nro_declaracion', label: 'N° de Declaración'},
          { key: 'nro_registro', label: 'N° Interno'},
          { key: 'fecha_aceptacion', label: 'Fecha Aceptación'},
          { key: 'estado', label: 'Estado'},
          'opciones',
        ],
        filter: null,
        filterOn: [],
        pageOptions: [20, 30, 50],
        currentPage: 1,
        perPage: 20,
        totalItems: 0,
        visibleModalImport: false,
        visibleModalForm: false,
        visibleModalDetail: false,
        visibleModalQuestion: false,
        loadingDelete: false,
        success: false,
        aduanas: [],
        carpeta: new Carpeta(),
        carpetaId: null,
        show_carpeta: null,
        codigoEscaneado: '',
        resultadoEscaneo: null,
      }
    },

    computed: {
      totalCarpetas() {
        return this.records.length
      }
    },

    mixins: [permission],
    
    components: {
      "modal-import": ModalImport,
      "modal-detail": ModalDetail,
      "modal-form": ModalForm,
      "modal-questtion": ModalQuestion,
      vueCustomScrollbar,
    },
  
    created() {
      this.showFoldersBox()
    },
  
    methods: {
      iniciarEscaneo() {
        // Agrega un event listener para escuchar el escaneo del lector QR
        console.log(1)
        window.addEventListener('keydown', this.escanearQR);
      },
      escanearQR(event) {
        // Verifica si la tecla presionada es Enter (código 13)
        if (event.keyCode === 13) {
          // Simulamos un resultado escaneado (deberías reemplazar esto con la lógica de tu lector QR real)
          const resultadoSimulado = 'Resultado del escaneo';

          // Actualizamos el resultado en el estado de Vue
          this.resultadoEscaneo = resultadoSimulado;

          // Removemos el event listener para evitar múltiples capturas
          window.removeEventListener('keydown', this.escanearQR);
        }
      },

      enfocarInput(event) {
        event.preventDefault();
        // this.$refs.inputHidden.style.display = "block"; // Mostrar el input
        // this.$nextTick(() => {
          this.$refs.inputHidden.focus();
        // });
      },

      capturarEscaneo(event) {
        // Verifica si se ha presionado la tecla "Enter" (código 13) o "Tab" (código 9)
        if (event.keyCode === 13 || event.keyCode === 9) {
          // Accede al valor escaneado en this.codigoEscaneado
          const codigoEscaneado = this.codigoEscaneado;

          // Realiza acciones con el código escaneado, por ejemplo, muestra en consola
          console.log('Código escaneado:', codigoEscaneado);

          // Limpia el campo de entrada para el siguiente escaneo si es necesario
          this.codigoEscaneado = '';

          // Evita que el evento se propague o realice otras acciones por defecto
          event.preventDefault();
        }
      },

      openModalForm() {
        this.listAduanas()
        this.visibleModalForm = true
      },

      closeModalForm() {
        this.visibleModalForm = false
        this.carpeta = new Carpeta()
      },

      successImport() {
        this.visibleModalImport = false
        this.$message.success('Los datos se importaron correctamente!')
        this.showFoldersBox()
      },

      showFoldersBox: async function() {
        this.isBusy = true
        try {
          const response = await BoxService.showFoldersBox(`cajas/carpetas/${this.id}`)
          if (response.status === 200) {
            this.box = response.data.data
            this.records = response.data.data.carpetas
            this.isBusy = false
          }
        } catch (err) {
          this.isBusy = false
        }
      },

      listAduanas: async function() {
        this.success = true
        const reponse = await AduanaService.listAduanas();
        if (reponse.status === 200) {
          this.aduanas = reponse.data
          this.success = false
        }
      },
      
      submitCarpeta: async function() {
        this.success = true
        this.$validator.errors.clear()
        this.carpeta.caja_id = this.id
        try {
          if(this.carpeta.id) {
            this._save = await BoxService.updateFolder(this.carpeta.id, this.carpeta)
          } else {
            this._save = await BoxService.storeFolder(this.carpeta)
          }
          if (this._save.status === 201 || this._save.status === 200) {
            this.closeModalForm()
            this.success = false
            this.showFoldersBox()
            this.$message.success(this._save.data.message)
          }
        } catch (err) {
          if(err.response.status === 422) this.$setErrorsFromResponse(err.response.data)
          if (err.response.status === 406) {
            this.closeModalForm()
            this.$notification.warning({
              message: 'Nota',
              description: err.response.data.message,
              duration: 10,
            })
          }
          this.success = false
        }
      },

      editCarpeta: async function(row) {
        this.listAduanas()
        this.carpeta = row
        this.visibleModalForm = true
      },

      showCarpeta: async function(row) {
        this.$store.dispatch("showLoader")
        try {
          const response = await BoxService.showFolder(`carpetas/${row.id}/show`)
          if (response.status === 200) {
            this.show_carpeta = response.data.data
            this.$store.dispatch("hideLoader")
            this.visibleModalDetail = true
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      questionDeleteCarpeta(row) {
        this.carpetaId = row.id
        this.visibleModalQuestion = true
      },

      deleteCarpeta: async function() {
        try {
          this.loadingDelete = true
          const response = await BoxService.deleteFolder(this.carpetaId)
          if (response.status === 200) {
            this.loadingDelete = false
            this.visibleModalQuestion = false
            this.showFoldersBox()
            this.$message.success(response.data.message)
          }
        } catch (err) {
          if (err.response.status === 406) {
            this.loadingDelete = false
            this.visibleModalQuestion = false
            this.$notification.warning({
              message: 'Nota',
              description: err.response.data.message,
              duration: 10,
            })
          }
          this.loadingDelete = false
        }
      },

      async pdfListFolders() {
        this.$store.dispatch("showLoader")
        try {
          const response = await BoxService.pdfListFolders(this.id)
          if (response.status === 200) {
            // let blob = new Blob([response.data])
            // let link = document.createElement("a")
            // link.href = window.URL.createObjectURL(blob)
            // link.download = `lista-carpetas-caja-${this.box.cod_interno}.pdf`
            // link.click()
            let file = new Blob([response.data], {type: 'application/pdf'})
            let fileUrl = URL.createObjectURL(file)
            window.open(fileUrl) 
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      async excelListFolders() {
        this.$store.dispatch("showLoader")
        try {
          const response = await BoxService.excelListFolders(this.id)
          if (response.status === 200) {
            let blob = new Blob([response.data])
            let link = document.createElement("a")
            link.href = window.URL.createObjectURL(blob)
            link.download = `lista-carpetas-caja-${this.box.cod_interno}.xlsx`
            link.click()
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      templateEstado(estado) {
        switch (estado) {
          case 'PENDIENTE':
            return (
              "<span class='badge badge-custom-6'>" +
              kendo.htmlEncode(estado) +
              "</span>"
            );
            break;
          case 'EN ALMACÉN':
            return (
              "<span class='badge badge-custom-4'>" +
              kendo.htmlEncode(estado) +
              "</span>"
            );
            break;
          case 'RETIRADA':
            return (
              "<span class='badge badge-custom-5'>" +
              kendo.htmlEncode(estado) +
              "</span>"
            );
            break;
          default:
            return (
              "<span class='badge badge-custom-4'>" +
              kendo.htmlEncode(estado) +
              "</span>"
            );
        }
      },
    }
  }
  </script>
  <style scoped>
    fieldset {
      background-color: #f9f9f9;
      border-radius: 4px;
    }

    legend {
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 4px;
      color: #000;
      font-size: 17px;
      font-weight: bold;
      padding: 3px 5px 3px 7px;
      width: auto;
    }

    .scroll-area {
      position: relative;
      margin: auto;
      height: 550px;
    }

    .info-registro {
      display: flex;
      justify-content: space-between;
      background-color: #edfffd;
      border: 1px solid #ccc;
      border-radius: 5px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .registros {
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .estado {
      display: flex;
      align-items: center;
      margin-right: 10px;
    }

    .detalle-servicio {
      background-color: #f0f0f0;
      border: 1px solid #ccc;
      border-radius: 5px;
      padding: 20px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .detalle {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .detalle:not(:last-child) {
      border-bottom: 1px solid #d3d2d2;
    }

    >>> .pagination .page-item.active .page-link {
      background-color: #287729;
      border-color: #287729;
    }
    >>> .page-link:focus {
      box-shadow: 0 0 0 0.2rem #287729;
    }
    .bg-custom {
      background-color: #d8d8d8;
    }
  </style>